import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { isProduction } from '@pn/core/utils/env';
import { DEFAULT_SYMBOL_STYLE } from '@pn/services/styles';
import { generateMapConfig, setOriginalLayers } from '.';

export const facilities: WorkspaceItem = setOriginalLayers({
  country: 'canada',
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'facilities',
  dataType: 'facilities',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Facilities',
  description: '200k facilities in Canada',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: generateMapConfig({
    itemId: 'facilities',
    type: LayerType.Icon,
    style: {
      ...DEFAULT_SYMBOL_STYLE,
      size: 28,
      font: ['petro-ninja-facilities-v4 Regular'],
    },
    source: {
      type: 'vector',
      minzoom: 9,
      maxzoom: 10,
      tiles: [
        isProduction()
          ? 'https://tiles.stackdx.com/facilities/{z}/{x}/{y}.pbf'
          : 'https://staging-tiles.stackdx.com/facilities/{z}/{x}/{y}.pbf',
      ],
    },
    sourceLayer: 'facilities',
  }),
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/facilities',
    requiredMapDataFields: ['internal_id', 'geometry', 'symbol'],
    requiredTableDataFields: [
      'internal_id',
      'geometry',
      'name',
      'operator',
      'status',
    ],
  },
  detailsSource: 'api',
  query: buildQuery({
    id: 'facilities',
    dataType: 'facilities',
  }),
  ...createInitInternalState({ isVisualized: false }),
});
